import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import DateCell from "components/cells/DateCell";
import ThreadIDCell from "views/Quote/Recent/ThreadIDCell";
import VehicleNumberCell from "./VehicleNumberCell";
import QuoteIDCell from "./QuoteIDCell";
import CustomerNumberCell from "./CustomerNumberCell";

type QuotesProps = {
  vehicleIds: number[];
  quoteData: FoundQuote[];
  quoteDataLoading: boolean;
}

export type FoundQuote = {
  VehicleID: number;
  VehicleNumber: string;
  Distance: number;
  QuoteID: number;
  Unassigned: boolean;
  ThreadID: string;
  RouteName: string;
  TotalDistance: number;
  Total: number;
  CustomerID: number | null;
  CustomerNumber: string;
  VehicleTypeName: string;
  FromLocation: string;
  FromDateTime: Date;
  ToLocation: string;
  CreatedDateTime: Date;
  AcceptedOfferCount: number;
  DeclinedOfferCount: number;
  ExpiredOfferCount: number;
  Pieces: number;
  Weight: number;
  CreatedByUserName: string;
  IsTemplate: boolean;
}

export const Quotes = ({ vehicleIds, quoteData, quoteDataLoading }: QuotesProps) => {

  if (vehicleIds.length === 0) {
    return <div className="mt-2 text-center">Select a vehicle to view quotes.</div>;
  }

  return <div className="mt-2">
    <Grid data={quoteData} size="small">
      <GridNoRecords>
        {quoteDataLoading ? "Loading..." : "No matching quotes found."}
      </GridNoRecords>
      <Column field="VehicleNumber" title="Vehicle #" cells={{ data: VehicleNumberCell }} width={100} />
      <Column field="Distance" title="Deadhead" filter="numeric" format="{0:n0} mi" width={80} />
      <Column field="QuoteID" title="Quote #" cells={{ data: QuoteIDCell }} width={130} />
      <Column field="ThreadID" title="Front" cells={{ data: ThreadIDCell }} />
      <Column field="TotalDistance" title="Loaded" filter="numeric" format="{0:n0} mi" width={80} />
      <Column field="Pieces" filter="numeric" format="{0:n0}" width={50} />
      <Column field="Weight" filter="numeric" format="{0:n0}" width={70} />
      <Column field="Total" title="Charges" filter="numeric" format="{0:c}" width={80} />
      <Column field="VehicleTypeName" title="Vehicle Type" />
      <Column field="CustomerNumber" title="Bill To" cells={{ data: CustomerNumberCell }} />
      <Column field="FromLocation" title="From" />
      <Column field="ToLocation" title="To" />
      <Column field="FromDateTime" title="Ship Date" filter="date" cells={{ data: DateCell }} width={120} />
      <Column field="CreatedDateTime" title="Created" filter="date" cells={{ data: DateCell }} width={120} />
    </Grid>
  </div>;
}